<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">LISTADO DE VUELOS</h5>
        <div class="col-12 col-md-12 row mt-4"> 
            
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label>Fecha Inicio:</label>
              <input
                type="date"
                v-model.trim="fecha_inicio"
                class="form form-control"
              />
          
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label>Fecha Fin:</label>
              <input
                type="date"
                v-model.trim="fecha_fin"
                class="form form-control"
              />
            </div>
          </div>
          <div
            class="col-12 col-md-3 "
            
          >
            <label><br> </label>
            <div class="form-group">
            
              <button
                class="btn btn-info"
                type="button"
                @click="
                  busquedaExtranjeroSicof(
                  
                    fecha_inicio,
                    fecha_fin
                  )
                "
              >
                Buscar
                <i class="fa fa-search"></i>
              </button>
              &nbsp;
              <button
                class="btn btn-secondary"
                type="button"
                @click="
                  limpiar()
                "
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>
        </div>
          
        <div class="row">
          <div
            class="table-responsive mt-3"
            style="overflow-y:scroll; height:700px;"
          >
           
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">CÓDIGO</small></th>
                <th><small class="font-weight-bold">EMPRESA</small></th>
                <th> <small class="font-weight-bold">FECHA REGISTRO</small></th>
                <th><small class="font-weight-bold">TOTAL</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontrados" :key="index" class="text-center">
                <td >
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.id_config_empresa }}</small>
                </td>
                <td>
                  <small>
                    {{ item.empresa}} <br />
                    
                  </small>
                </td>
                <td>
                  <small>{{
                    formatFecha(getDate(item.fecha_reg))
                  }}</small>
                </td>
                <td>
                  <small>{{ item.total }}</small>
                </td>
         
                
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
//import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "listaRobot",
  components: {
    Loading,
  },
  data() {
    return {
      parametro: '',
      fecha_inicio: '',
      fecha_fin: '',
      registrosEncontrados: [],
      cargando: false,
    };
  },
  methods: {
    async getListadoSicof() {
      let config = { headers: { token: this.token } };
      try {
        let resultados = await this.axios.get(`/ReporteVuelos`, config);
        this.registrosEncontrados = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async busquedaExtranjeroSicof(
      
      fecha_inicio,
      fecha_fin
    ) 
    { 
      
      if (fecha_inicio == null || fecha_inicio == '') {
        fecha_inicio = "1900-01-01";
      }
      if (fecha_fin == null || fecha_fin == '') {
        fecha_fin = "1900-01-01";
      }
        try {

          let resultados = await this.axios.get(
            `/ReporteVuelosPorFecha/${fecha_inicio}/${fecha_fin}`
          );
          this.registrosEncontrados = resultados.data.contenido;
        } catch (error) {
          console.log("catch: ", error);
          this.$swal({
            title: "Información",
            text: "Ocurrio un Error al realizar la consulta!",
            type: "error",
            confirmButtonText: "Aceptar",
          });
        }
    },
    async limpiar() {
      this.parametro = ''; 
      this.fecha_inicio ='';
      this.fecha_fin ='';
    this.getListadoSicof();
      
    },


    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
  },
  created() {
  this.getListadoSicof();
  },

};
</script>
